import React from 'react';
import Chip from '@Shared.Angular/flowingly.components/Chip/Chip';
import { IPublishedFlowModelTag } from '@Shared.Angular/@types/core/contracts/queryModel/flowModels/publishedFlowModelTag';

interface TagChipsListProps {
  tags: IPublishedFlowModelTag[];
}

const FlowModelSummaryTag: React.FC<TagChipsListProps> = ({ tags }) => {
  return (
    <div className="flow-model-summary-tag">
      {tags.map((tag) => (
        <Chip key={tag.id} name={tag.name} color={tag.color} />
      ))}
    </div>
  );
};

export default FlowModelSummaryTag;
